



















































































































import { vxm } from '../../store.vuex';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonUserInfo } from '../../models/referrals/commonuserinfo';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';
@Component({
  components: {},
})
export default class WereYouReferred extends Vue {
  $wlToastr: any;
  @Prop() bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop () isLastStep;
  private wereYouReferred: boolean = true;
  private referrer: CommonUserInfo = new CommonUserInfo();
  private noExample: boolean = true;

  @Watch('wereYouReferred')
  @Watch('referrer.firstName')
  @Watch('referrer.lastName')
  @Watch('referrer.email')
  referrerDataChange(newVal, oldVal) {
    let disableNextButton = false;
    if (this.minimumEntries >= 0 ? this.isRequiredStep : this.wereYouReferred) {
      disableNextButton = !(
        this.referrer.firstName &&
        this.referrer.lastName &&
        this.isValidEmail &&
        (this.referrer.phoneNumberValid || !this.referrer.phoneNumber)
      );
    }

    this.$emit('disable-next-button', disableNextButton);
  }
  disableNext(val) {
    this.$emit('disable-next-button', val);
  }

  goToNext() {
    this.$emit('go-to-next');
  }

  updateReferrerPhone(event) {
    this.referrer.phoneNumberValid = event.isValid;
    if (event.countryCallingCode && event.nationalNumber) {
      this.referrer.phoneNumber = `+${event.countryCallingCode} ${event.nationalNumber}`;
    } else {
      this.referrer.phoneNumber = event.phoneNumber;
    }

    this.referrerDataChange(
      this.referrer.phoneNumber,
      this.referrer.phoneNumber,
    );
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get companyName() {
    return vxm.jobs.CompanyInfo.companyName;
  }

  get isValidEmail() {
    if (!this.referrer.email) {
      return false;
    }
    const emailformat =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!this.referrer.email.match(emailformat)) {
      return false;
    }
    return true;
  }

  async mounted() {
    this.bus.$on('on-next-step', this.onNextStep);
    const currentStep = vxm.users.ProfileWizardSteps.find((step) => {
      return step.stepName === 'WERE_YOU_REFERRED';
    });
    if (currentStep && currentStep.meta) {
      const stepMeta = JSON.parse(currentStep.meta);
      if (typeof (stepMeta || {}).referredBySameCompanyDefaultValue === 'boolean') {
        this.wereYouReferred = stepMeta.referredBySameCompanyDefaultValue
      }
    }
    const response = await vxm.users.getWereYouReferredDetail();
    if (response && response.wereYouReferred) {
      this.referrer = response;
      this.wereYouReferred = true;
    } else if (response && response.wereYouReferred === false) {
      this.wereYouReferred = false;
    }
    // Enable next button (Requirement updated)
    //this.$emit('disable-next-button', false);
  }
  async onNextStep({ section }) {
    if (section.replace(/_/g, '-').toLowerCase() !== 'were-you-referred') {
      return;
    }
    if (this.referrer.wereYouReferred) {
      await vxm.users.validateMandatorySteps();
      if(vxm.users.MissedMandatorySteps.length && this.isLastStep) {
             this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
      }else{
             this.$emit('go-to-next');
      }
      return;
    }
    this.referrer.wereYouReferred = this.wereYouReferred;
    vxm.users
      .saveWereYouReferredDetail(this.referrer)
      .then(async (response) => {
        await vxm.users.getProfileStrength();
        if (response.success) {
          this.$wlToastr(
            'success',
            this.$t('gsu.were-you-referred.info-updated-text'),
            this.$t('guidedsignup.were-you-referred.header'),
          );
          await vxm.users.validateMandatorySteps();
          if(vxm.users.MissedMandatorySteps.length && this.isLastStep) {
             this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
          }else{
             this.$emit('go-to-next');
          }
          //if (this.wereYouReferred) {
          //  this.mailClientOpener(response);
          //}
        } else {
          this.$wlToastr(
            'error',
            `${this.$t('something.went.wrong')}. ${this.$t('please.try.again')}`,
            this.$t('guidedsignup.were-you-referred.header'),
          );
        }
      });
  }

  mailClientOpener(response) {
    const {
      referralDetail: { eventName: subject, referralMessages },
    } = response;

    let messageBody = '';
    const messages = referralMessages.filter((msg) => msg.type === '01');
    if (messages && messages.length > 0) {
      let body = messages[0].messageBody.replace(/<br\s*\/?>/g, '\r\n');
      messageBody = encodeURIComponent(body);
    }
    window.location.href = `mailto:${
      this.referrer.email
    }?subject=${encodeURIComponent(subject)}&body=${messageBody}`;
  }
}
